import { LanguageItem } from "./human.interface";

export class HumanizeDurationLanguage {
  languages: LanguageItem = {
    en: {
      y: (c: number) => {
        return "year" + (c === 1 ? "" : "s");
      },
      mo: (c: number) => {
        return "month" + (c === 1 ? "" : "s");
      },
      w: (c: number) => {
        return "week" + (c === 1 ? "" : "s");
      },
      d: (c: number) => {
        return "day" + (c === 1 ? "" : "s");
      },
      h: (c: number) => {
        return "hour" + (c === 1 ? "" : "s");
      },
      m: (c: number) => {
        return "minute" + (c === 1 ? "" : "s");
      },
      s: (c: number) => {
        return "second" + (c === 1 ? "" : "s");
      },
      ms: (c: number) => {
        return "millisecond" + (c === 1 ? "" : "s");
      },
      decimal: "."
    },
    ru: {
      y: (c: number) => {
        return ["лет", "год", "года"][this.getSlavicForm(c)];
      },
      mo: (c: number) => {
        return ["месяцев", "месяц", "месяца"][this.getSlavicForm(c)];
      },
      w: (c: number) => {
        return ["недель", "неделя", "недели"][this.getSlavicForm(c)];
      },
      d: (c: number) => {
        return ["дней", "день", "дня"][this.getSlavicForm(c)];
      },
      h: (c: number) => {
        return ["часов", "час", "часа"][this.getSlavicForm(c)];
      },
      m: (c: number) => {
        return ["минут", "минута", "минуты"][this.getSlavicForm(c)];
      },
      s: (c: number) => {
        return ["секунд", "секунда", "секунды"][this.getSlavicForm(c)];
      },
      ms: (c: number) => {
        return ["миллисекунд", "миллисекунда", "миллисекунды"][
          this.getSlavicForm(c)
        ];
      },
      decimal: ","
    },
    uk: {
      y: (c: number) => {
        return ["років", "рік", "роки"][this.getSlavicForm(c)];
      },
      mo: (c: number) => {
        return ["місяців", "місяць", "місяці"][this.getSlavicForm(c)];
      },
      w: (c: number) => {
        return ["тижнів", "тиждень", "тижні"][this.getSlavicForm(c)];
      },
      d: (c: number) => {
        return ["днів", "день", "дні"][this.getSlavicForm(c)];
      },
      h: (c: number) => {
        return ["годин", "година", "години"][this.getSlavicForm(c)];
      },
      m: (c: number) => {
        return ["хвилин", "хвилина", "хвилини"][this.getSlavicForm(c)];
      },
      s: (c: number) => {
        return ["секунд", "секунда", "секунди"][this.getSlavicForm(c)];
      },
      ms: (c: number) => {
        return ["мілісекунд", "мілісекунда", "мілісекунди"][
          this.getSlavicForm(c)
        ];
      },
      decimal: ","
    },
  };

  // Internal helper function for Russian and Ukranian languages.
  getSlavicForm(c: number) {
    if (Math.floor(c) !== c) {
      return 2;
    }
    
    if (
      (c >= 5 && c <= 20) ||
      (c % 10 >= 5 && c % 10 <= 9) ||
      c % 10 === 0
    ) {
      return 0;
    }
    
    if (c % 10 === 1) {
      return 1;
    }
    
    if (c > 1) {
      return 2;
    }

    return 0;
  }
}